// extracted by mini-css-extract-plugin
module.exports = {"leadForm":"LeadForm_leadForm__XFcEQ","footnote":"LeadForm_footnote__9Zxqc","footnoteHidden":"LeadForm_footnoteHidden__8QGLB"};